module.exports = __webpack_public_path__ + "img/twitter.c191602f.svg";